import NiceModal from "@ebay/nice-modal-react"
import { createContext, type ReactNode, useContext } from "react"

const CodeModalProviderContext = createContext(false)

// NiceModal keeps its dispatcher at module scope, so nested providers can
// dispatch a close to a different store than the one that owns the dialog.
// Keep reusable shells self-contained without creating a second provider
// when the complete app already supplies one.
export function CodeModalProvider({ children }: { children: ReactNode }) {
    const hasProvider = useContext(CodeModalProviderContext)
    if (hasProvider) return <>{children}</>

    return (
        <CodeModalProviderContext.Provider value={true}>
            <NiceModal.Provider>{children}</NiceModal.Provider>
        </CodeModalProviderContext.Provider>
    )
}
